import React, { useEffect, useRef, useState } from "react";

import { SearchInner, SearchWrapper } from "./search-field.styles";
import cx from "classnames";
import { Nullable } from "../../../types/common";
import { SearchFieldProps } from "./search-field.props";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { Keyboard } from "../../../types/keyboard/keyboard.enum";

export const SearchField = (props: SearchFieldProps) => {
  const [searchTerm, setSearchTerm] = useState<Nullable<string>>("");
  const [subject] = useState<Subject<string>>(new Subject());
  const [subscription, setSubscription] = useState<Nullable<Subscription>>(null);
  const firstUpdate = useRef(true);

  useEffect(
    () => {
      if (!subscription && subject) {
        setSubscription(
          subject.pipe(debounceTime(props.debounceTime || 500)).subscribe(props.onSearch)
        );
      }

      return () => {
        if (subscription) {
          subscription.unsubscribe();
          setSubscription(null);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (Boolean(props.resetSearch)) {
      setSearchTerm("");
    }
  }, [props.resetSearch]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    }
  }, [firstUpdate, props]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    subject.next(e.target.value);
  };

  const onKeyUp = (event: React.KeyboardEvent) => {
    if (event.key === Keyboard.Escape && props.onCancel) {
      setSearchTerm("");
      props.onCancel();
    }
  };

  return (
    <SearchWrapper className={cx(props.size)}>
      <SearchInner>
        <input
          aria-label={props.label}
          autoComplete="off"
          className="form-control"
          disabled={props.isDisabled}
          id={props.id}
          name={props.id}
          onKeyUp={onKeyUp}
          onChange={handleChange}
          placeholder={props.placeholder}
          ref={props.ref}
          type="search"
          value={searchTerm || ""}
        />
      </SearchInner>
    </SearchWrapper>
  );
};
